import { useErrorReporter } from '@/composables/useErrorReporter'
import { useToast } from '@/composables/useToast'

export function copyToClipboard() {
	const isCopiedToClipboard = ref(false)

	const copyHyperlinkToClipboard = async (data: {
		linkUrl: string
		displayText: string
	}) => {
		const { addToast } = useToast()
		const { bugsnagReport } = useErrorReporter()

		const { linkUrl, displayText } = data
		const markdown: HTMLAnchorElement = document.createElement('a')

		markdown.href = linkUrl
		markdown.textContent = displayText

		const linkHtmlString = markdown.outerHTML

		const blobHtml = new Blob([ linkHtmlString ], { type: 'text/html' })
		const blobText = new Blob([ displayText ], { type: 'text/plain' })

		const clipboardItem = new ClipboardItem({
			'text/html': blobHtml,
			'text/plain': blobText
		})

		try {
			await navigator.clipboard.write([ clipboardItem ])
			isCopiedToClipboard.value = true
			addToast({
				title: 'Link Copied to Clipboard!',
				links: [ {
					text: displayText,
					to: linkUrl
				} ],
				notificationType: 'success',
				options: { duration: 1500 }
			})
		} catch (err) {
			bugsnagReport({
				error: err as Error ?? new Error(`Failed to copy link to clipboard ${displayText}`),
				showToast: true,
				toast: {
					title: 'Failed to Copy Link to Clipboard',
					message: `${displayText}`,
					notificationType: 'error'
				}
			})
		}
	}
	const copyTextToClipboard = async (text: string) => {
		const { addToast } = useToast()
		const { bugsnagReport } = useErrorReporter()

		const blobText = new Blob([ text ], { type: 'text/plain' })
		const clipboardItem = new ClipboardItem({ 'text/plain': blobText })

		try {
			await navigator.clipboard.write([ clipboardItem ])
			isCopiedToClipboard.value = true
			addToast({
				title: 'Text Copied to Clipboard!',
				notificationType: 'success',
				options: { duration: 1500 }
			})
		} catch (err) {
			bugsnagReport({
				error: err as Error ?? new Error(`Failed to copy text to clipboard ${text}`),
				showToast: true,
				toast: {
					title: 'Failed to Copy Text to Clipboard',
					message: `${text}`,
					notificationType: 'error'
				}
			})
		}
	}

	const resetClipboardState = () => {
		isCopiedToClipboard.value = false
	}

	return {
		copyHyperlinkToClipboard,
		copyTextToClipboard,
		isCopiedToClipboard,
		resetClipboardState
	}
}
